export default `
.opd {
    padding: 20px 50px;
    max-width: 900px;
    margin: 0 auto;
}
h1 {
    text-align: center;
    margin-bottom: 30px;
}
.form {
    margin-bottom: 20px;
}
form > div {
    line-height: 25px;
    margin-bottom: 10px;
}
form > div:first-child .ant-form-item {
    margin-left: 3px;
    margin-right: 3px;
    width: 100%;
}
.ant-form-item {
    display: inline-block;
    margin-bottom: 0;
}
input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #d9d9d9;
    font: inherit;
    color: #000;
    background-color: none !important;
}
.ant-checkbox input {
    opacity: 0;
    position: absolute;
}
.ant-checkbox {
    position: relative;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 7px;
    vertical-align: middle;
}
.ant-checkbox.ant-checkbox-checked {
    background-color: #1890ff;
    border-color: #1890ff;
}
.ant-checkbox.ant-checkbox-checked:after {
    content: '';
    width: 2.7px;
    height: 7.1px;
    position: absolute;
    left: 6px;
    top: 2px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(45deg);
}
.ant-radio input {
    width: 50px;
}
.ant-radio-wrapper-checked input {

}
.cancel-button {
    display: none;
}
.opd-date {
    display: block;
}
.lang-select, .ant-collapse-arrow {
    display: none;
}
.textarea {
    border-bottom: 1px solid #d9d9d9;
    background-color: #ebebe4;
    padding: 5px;
    line-height: normal;
}
.anticon, .ant-collapse-content-box br {
    display: none;
}
.ant-collapse-header {
    font-size: 24px;
    font-weight: bold;
    margin-top: 40px;
    text-align: center;
}
.ant-collapse-content-box > b {
    text-align: center;
    display: block;
}
ol {
    counter-reset: section;
}
ol > li {
    list-style: none;
    counter-increment: section;
}
ol > li:before {
    content: counters(section,".") ". ";
}
ol > li ol {
    counter-reset: subsection;
}
ol > li ol > li {
    counter-increment: subsection;
}
ol > li ol > li:before {
    content: counter(section) "." counter(subsection) ". ";
}
ol > li ol > li ol {
    counter-reset: subsubsection;
}
ol > li ol > li ol > li {
    counter-increment: subsubsection;
}
ol > li ol > li ol > li:before
    content: counter(section) "." counter(subsection) "." counter(subsubsection) ". ";
}
.text-ref {
    display: block;
}
.text-ref:before {
    content: '';
    height: 1px;
    width: 260px;
    background: #000;
    display: inline-block;
    position: absolute;
    margin-top: -8px;
}
`;
